export const NONAME_ROUTING = [
    {
        path: '/noname',
        name: 'noname',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Hàng không tên', pathName: 'noname', icon: 'fa fa-question-circle' },
            ]
        },
        component: () => import('./Transition.vue'),
        redirect: { name: 'noname-index' },
        children: [
            {
                path: '/hang-khong-ten.html',
                name: 'noname-index',
                component: () => import('./list/List.vue'),
            },
        ]
    }
];